import { defineComponent as _defineComponent } from 'vue'
import { Configuration } from "@/app/helpers/QueryParams";
import { computed } from "vue";
import store from "@/store";
import RationalImage from "@/components/RationalImage"


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryCard',
  props: {
    config: null,
    title: null,
    showThumb: null
  },
  setup(__props: any) {

const props = __props as {
  config: Configuration;
  title: string;
  showThumb?: Boolean;
};




const leaseType = computed(() => store.state.settings.leaseForm === 1 ? 'Private Lease' : 'Operational Lease')
const isPrivateLease = computed(() => store.state.settings.leaseForm === 1)
const colorOption = computed(() => props.config.firstOptionForType('color'))
const totalOwnRisk = computed(() => props.config.firstOptionForType('own-risk')
    ?.getMatrixPrice(props.config.duration, props.config.mileage))

const totalOptions = computed(() => props.config.optionTotalsForType('extra'))
const totalAccessories = computed(() => props.config.optionTotalsForType('accessory'))
const totalComponents = computed(() => props.config.optionTotalsForType('component'))
const totalPrice = computed(() => props.config.totalPrice())

const priceKm = computed(() => props.config.edition?.getMatrixPriceKm(props.config.duration, props.config.mileage))
const priceUnderKm = computed(() => props.config.edition?.getMatrixPriceUnderKm(props.config.duration, props.config.mileage))

return { __sfc: true,props, leaseType, isPrivateLease, colorOption, totalOwnRisk, totalOptions, totalAccessories, totalComponents, totalPrice, priceKm, priceUnderKm, RationalImage }
}

})